document.addEventListener('DOMContentLoaded', () => {
  const scrollToTop = document.querySelector('.scroll-to-top');
  const edgePanel = document.querySelector('.edge-panel');
  const edgePanelEu = document.querySelector('.edge-panel__eu');
  const edgePanelReveal = document.querySelector('.edge-panel__reveal');

  scrollToTop.addEventListener('click', () => {
    window.scrollTo({ top: 0, behavior: 'smooth' });
  });

  edgePanelReveal.addEventListener('click', () => {
    edgePanel.classList.toggle('is-open');
    edgePanelEu.classList.toggle('is-open');
    edgePanelReveal.classList.toggle('is-open');
  });
});
